import { motion } from 'framer-motion';
import { COPY } from '../constants/brand';

export const SocialProof = () => {
  return (
    <section 
      id="social-proof" 
      className="py-8 md:py-10 bg-aya-surface border-t border-b border-aya-border"
      data-testid="social-proof-section"
    >
      <div className="container mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto text-center"
        >
          {/* Title */}
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-white mb-4">
            <span className="block lg:inline">Built by the community,</span>{' '}
            <span className="block lg:inline">for the community.</span>
          </h2>

          {/* Subtitle */}
          {/* <p className="text-zinc-400 text-base md:text-lg mb-10">
            {COPY.socialProof.subtitle}
          </p> */}

          {/* Badges */}
          {/* <div 
            className="flex flex-wrap justify-center gap-4"
            data-testid="social-proof-badges"
          >
            {COPY.socialProof.badges.map((badge, index) => (
              <motion.div
                key={badge}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="
                  px-5 py-2.5
                  border border-white/20 
                  text-white/70 text-sm font-medium
                  hover:border-aya-yellow hover:text-aya-yellow
                  transition-all duration-300
                "
                data-testid={`badge-${index}`}
              >
                {badge}
              </motion.div>
            ))}
          </div> */}
        </motion.div>
      </div>
    </section>
  );
};

export default SocialProof;
